// Which back-cover photo is drawn full-page, and which go in the centred grid —
// ONE rule for the editor, the preview and the PDF (owner, 2026-10-16, #MAN-696335).
//
// ⚠️ A BLANK (« vierge ») COVER SHOWS ITS BACK PHOTO FULL-FRAME. The editor and
// the preview always did (`isBlankTheme` → `imgs[0]` fills the panel), but the
// PDF only knew the ⋯ « pleine page » flag. With no flag it put the same photo
// in the 70 % centred square — the printed back looked nothing like the editor.
//
// Pure. Guard: backCoverPlan.test.ts
export interface BackEntry { url: string | null; full: boolean }

/** True for a cover with no artwork (cover_id null) or a cover whose back style is 'blank'. */
export function isBlankBack(cover: { back_cover_style?: string | null } | null | undefined): boolean {
  return !cover || cover.back_cover_style === 'blank';
}

export function backCoverPlan(entries: BackEntry[], blank: boolean): { fullPage: string | null; grid: string[] } {
  if (blank) {
    // Mirrors the editor: the FIRST image, full-frame; nothing else is drawn.
    const first = entries.find((e) => e.url);
    return { fullPage: first?.url ?? null, grid: [] };
  }
  return {
    fullPage: entries.find((e) => e.full && e.url)?.url ?? null,
    grid: entries.filter((e) => !!e.url && !e.full).map((e) => e.url as string),
  };
}
